"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimateHtmlComponent = void 0;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (Object.prototype.hasOwnProperty.call(b, p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function isUpgraded(element) {
    return "__rm_upgraded__" in element;
}
function hasOverlay(stage) {
    return stage && !!stage.domOverlay;
}
var AnimateHtmlComponent = /** @class */ (function (_super) {
    __extends(AnimateHtmlComponent, _super);
    function AnimateHtmlComponent(mc, html, fn) {
        var _this_1 = _super.call(this, mc.mode, mc.startPosition, mc.loop, mc.labels) || this;
        _this_1.__rm_upgraded__ = true;
        _this_1.cancelStageListener = null;
        _this_1.nominalBounds = new createjs.Rectangle(0, 0, 0, 0);
        _this_1.handleRemoved = function () {
            _this_1.updateDom();
        };
        var nominalBounds = mc.nominalBounds;
        Object.setPrototypeOf(mc, AnimateHtmlComponent.prototype);
        var _this = mc;
        _this.__rm_upgraded__ = true;
        _this.init(html);
        _this.nominalBounds = nominalBounds;
        if (fn)
            fn();
        return mc;
    }
    AnimateHtmlComponent.upgrade = function (mc, html, fn) {
        if (isUpgraded(mc)) {
            return mc;
        }
        return new AnimateHtmlComponent(mc, html, fn);
    };
    AnimateHtmlComponent.prototype.init = function (html) {
        var _this_1 = this;
        var el = document.createElement("div");
        el.style.position = "absolute";
        el.style.top = "0px";
        el.style.left = "0px";
        el.style.pointerEvents = "auto";
        var shadow = el.attachShadow({ mode: "open" });
        shadow.innerHTML = html;
        this.addEventListener("removed", function () { return _this_1.updateDom(); });
        this.element = el;
    };
    AnimateHtmlComponent.prototype.getContainer = function () {
        return hasOverlay(this.stage) ? this.stage.domOverlay : document.getElementById("dom_overlay_container");
    };
    AnimateHtmlComponent.prototype.updateDom = function () {
        var _this_1 = this;
        if (this.stage && !this.element.offsetParent) {
            var container = this.getContainer();
            if (!container) {
                throw new Error("AnimateHtmlComponent: Container wasn't found!");
            }
            if (!this.element.offsetParent) {
                container.appendChild(this.element);
            }
            this.cancelStageListener = this.stage.addEventListener("drawstart", function () {
                if (!_this_1.stage && _this_1.element.offsetParent) {
                    _this_1.element.remove();
                    if (_this_1.cancelStageListener)
                        _this_1.cancelStageListener();
                }
            });
        }
        else if (!this.stage && this.element.offsetParent) {
            this.element.remove();
            if (this.cancelStageListener)
                this.cancelStageListener();
        }
    };
    AnimateHtmlComponent.prototype.updatePosition = function () {
        var _this = this;
        var props = this.getConcatenatedDisplayProps(_this._props), mat = props.matrix;
        var tx1 = mat.decompose();
        var sx = tx1.scaleX;
        var sy = tx1.scaleY;
        var dp = 1; // window.devicePixelRatio || 1;
        var w = this.nominalBounds.width; // * sx;
        var h = this.nominalBounds.height; // * sy;
        var dx = this.nominalBounds.x * sx;
        var dy = this.nominalBounds.y * sy;
        mat.tx /= dp;
        mat.ty /= dp;
        mat.a /= dp; // * sx;
        mat.b /= dp; // * sx;
        mat.c /= dp; // * sy;
        mat.d /= dp; // * sy;
        // const origX = this.nominalBounds.x + this.regX;
        // const origY = this.nominalBounds.y + this.regY;
        // console.log(this.regX, this.regY, this.nominalBounds.x, this.nominalBounds.y);
        this.element.style.setProperty("transform-origin", this.regX + "px " + this.regY + "px");
        var x = mat.tx + dx + this.regX * mat.a + this.regY * mat.c - this.regX;
        var y = mat.ty + dy + this.regX * mat.b + this.regY * mat.d - this.regY;
        var tx = "matrix(" + mat.a + "," + mat.b + "," + mat.c + "," + mat.d + "," + x + "," + y + ")";
        this.element.style.setProperty("transform", tx);
        this.element.style.setProperty("width", "".concat(w, "px"));
        this.element.style.setProperty("height", "".concat(h, "px"));
        // this.element.style.setProperty("font-size", `${sx * 100}px`);
    };
    AnimateHtmlComponent.prototype.draw = function ( /*ctx: CanvasRenderingContext2D, ignoreCache?: boolean*/) {
        this.updateDom();
        this.updatePosition();
        return true;
    };
    AnimateHtmlComponent.prototype.querySelector = function (s) {
        return this.element.shadowRoot.querySelector(s);
    };
    AnimateHtmlComponent.prototype.querySelectorAll = function (s) {
        return this.element.shadowRoot.querySelectorAll(s);
    };
    return AnimateHtmlComponent;
}(createjs.MovieClip));
exports.AnimateHtmlComponent = AnimateHtmlComponent;
//# sourceMappingURL=html-component.js.map
//# sourceMappingURL=module.js.map